export default {
  description: 'Hier ist eine Zusammenfassung unserer Libraries auf GitHub.',
  title: 'Freie Java Libraries'
}
